import { jsx } from 'react/jsx-runtime';

/** ![underlineIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNNiA0djZhNiA2IDAgMCAwIDEyIDBWNE00IDIwaDE2Ii8+PC9zdmc+) */
const underlineIcon = /*#__PURE__*/jsx("path", {
  d: "M6 4v6a6 6 0 0 0 12 0V4M4 20h16"
});

export { underlineIcon };
